import React from 'react';
import PropTypes from 'prop-types';

import IEdit from '@meronex/icons/fi/FiEdit2';
import IDelete from '@meronex/icons/fi/FiTrash2';

import { useTheme } from '@material-ui/core/styles';

const TeamItem = (props) => {
  const { onEdit, onDelete, team } = props;
  const theme = useTheme();
  const isDark = theme.palette.type === 'dark';

  const [hovered, setHovered] = React.useState(false);

  const textColor = isDark ? '#e2e8f0' : '#0f172a';
  const mutedColor = isDark ? '#94a3b8' : '#64748b';
  const borderColor = isDark ? 'rgba(255,255,255,0.06)' : '#f1f5f9';
  const hoverBg = isDark ? 'rgba(255,255,255,0.04)' : '#f8fafc';

  const membersCount = (team.members || []).length;

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        padding: '12px 16px',
        borderBottom: `1px solid ${borderColor}`,
        cursor: 'pointer',
        backgroundColor: hovered ? hoverBg : 'transparent',
        transition: 'background-color 0.15s',
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <span style={{
          fontSize: '14px',
          fontWeight: 600,
          color: textColor,
        }}>
          {team.name}
        </span>
        <div style={{
          fontSize: '12px',
          color: mutedColor,
          marginTop: '2px',
        }}>
          {membersCount} member{membersCount === 1 ? '' : 's'}
        </div>
      </div>
      <div style={{
        display: 'flex',
        gap: '4px',
        flexShrink: 0,
        opacity: hovered ? 1 : 0.3,
        transition: 'opacity 0.15s',
      }}>
        <div
          onClick={(e) => { e.stopPropagation(); onEdit(team); }}
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6366f1',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(99,102,241,0.15)' : '#eef2ff'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <IEdit size={15} />
        </div>
        <div
          onClick={(e) => { e.stopPropagation(); onDelete(team); }}
          style={{
            width: '32px',
            height: '32px',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: isDark ? '#f87171' : '#dc2626',
            cursor: 'pointer',
            transition: 'background-color 0.15s',
          }}
          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = isDark ? 'rgba(248,113,113,0.1)' : '#fef2f2'; }}
          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
        >
          <IDelete size={15} />
        </div>
      </div>
    </div>
  );
};

TeamItem.propTypes = {
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  team: PropTypes.object,
};

TeamItem.defaultProps = {
  onEdit: () => {},
  onDelete: () => {},
};
export default TeamItem;
